import { render, staticRenderFns } from "./Addteacher.vue?vue&type=template&id=4c8d0312&scoped=true"
import script from "./Addteacher.vue?vue&type=script&lang=js"
export * from "./Addteacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d0312",
  null
  
)

export default component.exports